import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const routerPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
const route = () =>
  import( /* webpackChunkName: "group_Index" */ '@/view/route')
const sourceGoods = () =>
  import( /* webpackChunkName: "group_Index" */ '@/view/sourceGoods')
const orderList = () =>
  import( /* webpackChunkName: "group_Index" */ '@/view/orderList')
export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'route',
    component: route,
    redirect: {
      name: 'sourceGoods'
    },
    children: [{
      path: '/sourceGoods',
      name: 'sourceGoods',
      component: sourceGoods,
      meta: {
        title: "精选货源"
      },
    }, {
      path: '/orderList',
      name: 'orderList',
      component: orderList,
      meta: {
        title: "订单列表"
      },
    }]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js